const MENUS = ['/'];

const ACTIVE_ID_MENUS = ['/'];

enum SideNavMenuConstants {
  DASHBOARD,
}

enum ActiveIdSideNavMenuConstants {
  DASHBOARD,
}
export { MENUS, ACTIVE_ID_MENUS, SideNavMenuConstants, ActiveIdSideNavMenuConstants };
